import { Box } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { IconHeader } from '@/components/shared/components/IconHeader';
import { ApplicationType } from '@/config/types';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface ConditionsSummaryWrapperProps {
  title: string;
  surtitle: string;
  iconName: string;
  id: string;
  children: React.ReactNode;
  applicationType?: ApplicationType;
  principal?: { amount: number; currency: Currency };
}

export const ConditionsSummaryWrapper = ({
  title,
  surtitle,
  iconName,
  id,
  principal,
  children,
  applicationType,
}: ConditionsSummaryWrapperProps) => {
  return (
    <>
      <Box width={'100%'} display={'inline-flex'} justifyContent={'space-between'} pb={4}>
        <IconHeader
          labelTid={title}
          surLabelTid={surtitle}
          iconName={iconName}
          color={'secondary'}
          copyToClipboard={{ value: id, textId: applicationType ? `COPY_${applicationType}_ID` : 'COPY_ID' }}
        />
        {principal && (
          <Font variant={'h2'} color={'title'} style={{ alignSelf: 'center' }}>
            {formatMoney(amountToValueMoneyMapper(principal))}
          </Font>
        )}
      </Box>
      <Box>{children}</Box>
    </>
  );
};
